export function isFilteredFolderItem(o) {
  return typeof o.highlightStart !== 'undefined';
}